import React, { useState } from 'react'
import { Form } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import logo from "../../assets/logos/M3_Logo.png";
import OtpComponent from '../Otp/OtpComponent';
import otpVerification from './otpVerificationForSignUp';
import OverLayModal from '../CustomModal/OverlayModal';
import { LoadingOutlined } from '@ant-design/icons';
import AwsResetOtp from '../../utils/AWS/resendOtp';
import toastMessage from '../../utils/toastMessage';


const rules = [{ required: true, message: 'This field is required' }];

function verifyOTP(cognitoUser, otp) {
    cognitoUser.sendMFACode(otp, {
        onSuccess: (session) => {
            console.log('OTP Verified Successfully', session);
            // Redirect to dashboard
        },
        onFailure: (err) => {
            console.error('OTP Verification Failed', err);
        }
    });
}


const LoginOtpModal = ({ open, onOk, onCancel, email, onEmailVerification, }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState({ otpDone: false });

    const handleChildClick = (e) => {
        e.stopPropagation();
    };

    const handleOtpLoadingAndCloseModal = (isVerify) => {
        if(!isVerify){
            setLoading({ otpDone: false });
        }
        else {
            setLoading({ otpDone: false });
            onCancel();
            onEmailVerification();
        }
    }

    const handleOtpDone = (otp) => {
        console.log(otp, "otp");
        setLoading({ otpDone: true });
        otpVerification(email, otp, handleOtpLoadingAndCloseModal);
    }

    const callBackForOtpResend = (error, msg) => {
        if(error){
         toastMessage(error, "error");   
        }
        else{
            toastMessage(msg, "success");
        }
        setLoading({ otpDone: false })
    }

    const resendOtp = () => {
        setLoading({ otpDone: true });
        AwsResetOtp(email, callBackForOtpResend);
    }

    if(!open || !email) return;
  return (
    <div 
        className='fixed top-0 left-0 z-[99] bg-gray-500/90 h-screen w-screen flex justify-center items-center overflow-y-auto' 
        onClick={onCancel}
    >
        <OverLayModal isShow={loading?.otpDone}><LoadingOutlined size={30} /></OverLayModal>
        <div onClick={handleChildClick} className="w-full flex flex-col justify-center items-center">
            <div className='modalConatainerBg w-[350px] sm:w-[500px] min-h-[470px] rounded-xl flex flex-col items-center'>
                {/* <div onClick={onCancel} className="w-full flex justify-end mr-12 mt-7 hover:text-lightOrange cursor-pointer">
                    <CloseOutlined style={{ fontSize: 18 }} />
                </div> */}
                <div className='mt-8'>
                    <img src={logo} alt="logo" width={110} />
                </div>
                <div className='mt-10 mb-6'>
                    <p className="text-lg font-bold font-satoshi text-center">Confirm Your Email</p>
                    <p className="text-gray-500 text-center mt-3">Otp has been send to your entered email</p>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <OtpComponent handleOtpDone={handleOtpDone} />
                </div>
                <p onClick={resendOtp} className='mt-8 text-darkOrange cursor-pointer px-4 py-1 border-2 border-darkOrange rounded-lg hover:bg-darkOrange hover:text-white'>Resent OTP</p>
                <p className='mt-8 text-darkOrange hover:text-lightOrange cursor-pointer'
                    onClick={onCancel}
                >
                    Do you want to change Email ?
                </p>
            </div>
        </div>
    </div>
  )
}

export default LoginOtpModal;
